import { Modal } from '../ui/Modal';
import { ProgressBar } from '../ui/ProgressBar';

export interface UploadProgressModalProps {
  open: boolean;
  filename?: string;
  progress: number;
  onCancel?: () => void;
}

export function UploadProgressModal({
  open,
  filename,
  progress,
  onCancel,
}: UploadProgressModalProps) {
  return (
    <Modal
      open={open}
      onClose={() => onCancel?.()}
      title="Загружаем файл"
      dismissible={Boolean(onCancel)}
      size="sm"
    >
      <p className="mb-3 truncate text-sm text-text-muted" title={filename}>
        {filename ?? '—'}
      </p>
      <ProgressBar value={progress} label={`${progress}%`} />
    </Modal>
  );
}
